
import Image from 'next/legacy/image'

import forgetPassStyles from '../../styles/modules/forgetPass.module.css';
import ProgressBarStyles from './progressbar.module.css';

export default function Layout (props) {
  const { step, stepTitle = [], className = '' } = props
  const switchClassName = (step) => {
    if (step === 1) {
      return forgetPassStyles.will
    }
    if (step === 3) {
      return forgetPassStyles.done
    }
    return ''
  }
  return (
    <div className={className}>
      <div className={`${ProgressBarStyles.processBar}`}>
        <div className={ProgressBarStyles.processBarIcon}>
          <Image
            alt=''
            src={require('../../images/icon/processBarChecked.webp')}
            layout="fixed"
            width={20}
            height={20}
          />
          <div className={step === 1 ? ProgressBarStyles.processBarIconLineUnChecked : ProgressBarStyles.processBarIconLine}/>
          <Image
            alt=''
            src={require(step === 2 || step === 3 ? '../../images/icon/processBarChecked.webp' : '../../images/icon/processBarUnChecked.webp')}
            layout="fixed"
            width={20}
            height={20}
          />
          {
            stepTitle.length === 3 && (
              <>
              <div className={step === 3 ? ProgressBarStyles.processBarIconLine : ProgressBarStyles.processBarIconLineUnChecked}/>
              <Image
                alt=''
                src={require(step === 3 ? '../../images/icon/processBarChecked.webp' : '../../images/icon/processBarUnChecked.webp')}
                layout="fixed"
                width={20}
                height={20}
              />
              </>
            )
          }
        </div>
      </div>
      {
        stepTitle.length === 3
          ? (
          <div className={forgetPassStyles.stepTitle}>
            <span className={step === 1 ? '' : forgetPassStyles.done}>
              {stepTitle[0]}
            </span>
            <span className={switchClassName(step)}>
              {stepTitle[1]}
            </span>
            <span className={step === 3 ? '' : forgetPassStyles.will}>
              {stepTitle[2]}
            </span>
      </div>
            )
          : (
            <div className={forgetPassStyles.stepTitle}>
            <span className={step === 1 ? '' : forgetPassStyles.done}>
              {stepTitle[0]}
            </span>
            <span className={switchClassName(step)}>
              {stepTitle[1]}
            </span>
      </div>
            )
      }

    </div>
  )
}
